export default "__VITE_ASSET__D9w93toq__"